module.exports = __webpack_public_path__ + "HRA Card - client info needed.pdf";